import { DashboardRoutes } from "@/router";
import { useAppTranslation } from "@/utils";
import { SamanApis } from "@payping/api";
import { FeatherLeft, FiCreditCard, PhRChartPie } from "@payping/icons";
import { dateFormats, jalaliNow } from "@payping/utils/dateUtils";
import { Flex, Menu, Typography, usePaypingContext } from "@payping/web-components";
import { Link } from "react-router-dom";
import { useAsync } from "react-use";
import { useSelectedTab } from "./useSelectedTab";

const DigitalAccountMenu = () => {
  const { t } = useAppTranslation();
  const { breakpoints } = usePaypingContext();
  const { lg } = breakpoints;
  const selectedTab = useSelectedTab();

  const { value } = useAsync(
    async () =>
      SamanApis.getDepositStatementsWithDepositStatementModelWithCancellationTokenGet(
        undefined,
        1,
        1,
        jalaliNow({
          manipulate: [{ args: [1, "year"], method: "subtract" }],
          toFormat: dateFormats.standard.utcDateTime,
        })
          .object.startOf("day")
          .toDate(),
        jalaliNow({ toFormat: dateFormats.standard.utcDateTime }).object.toDate(),
        undefined,
        undefined,
      ),
    [],
  );

  // Menu items for both desktop and mobile
  const menuItems = [
    {
      key: DashboardRoutes.digitalAccount.yourAccount.url,
      icon: <FiCreditCard strokeWidth={2} />,
      label: <Link to={DashboardRoutes.digitalAccount.yourAccount.url}>{t("digitalAccount.menu.overview")}</Link>,
    },
    ...(value?.statements?.length
      ? [
          {
            key: DashboardRoutes.digitalAccount.saman.turnOver.url,
            icon: <PhRChartPie strokeWidth={2} />,
            label: t("digitalAccount.menu.transferReports"),
            children: [
              {
                key: DashboardRoutes.digitalAccount.saman.turnOver.url,
                label: (
                  <Link to={DashboardRoutes.digitalAccount.saman.turnOver.url}>
                    {t("digitalAccount.samanTurnOver.title")}
                  </Link>
                ),
              },
              {
                key: DashboardRoutes.digitalAccount.saman.request.url,
                label: (
                  <Link to={DashboardRoutes.digitalAccount.saman.request.url}>
                    {t("digitalAccount.menu.requestsTransfer")}
                  </Link>
                ),
              },
            ],
          },
        ]
      : []),
  ];

  const desktopMenu = (
    <Flex vertical className={"tw:h-full!"}>
      {/* < تایتل = "حساب دیجیتال" > */}
      <Typography.Text type={"secondary"}>{t("tabs.digitalAccount")}</Typography.Text>

      {/* < منو گزینه حساب دیجیتال > */}
      <Menu mode="inline" className={"tw:h-full! tw:border-b-0!"} items={menuItems} selectedKeys={[selectedTab]} />
    </Flex>
  );

  const mobileMenu = (
    <Flex vertical className={"tw:p-4! tw:py-12!"}>
      {/* < تایتل = "حساب دیجیتال" > */}
      <Typography.Title className={"tw:mb-8! font-bold"} level={4}>
        {t("tabs.digitalAccount")}
      </Typography.Title>

      {/* < منو گزینه حساب دیجیتال > */}
      <Menu
        mode="inline"
        style={{ border: 0 }}
        items={menuItems.map((item) => {
          if (!item.children) {
            return {
              ...item,
              label: (
                <div className={"justify-between"}>
                  <Flex justify={"space-between"}>{item.label}</Flex>
                  <FeatherLeft width={14} />
                </div>
              ),
            };
          }
          return item;
        })}
        defaultSelectedKeys={[selectedTab]}
      />
    </Flex>
  );

  return lg ? desktopMenu : mobileMenu;
};

export default DigitalAccountMenu;
